import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.68342 0.683417C3.121 0.245833 3.71449 0 4.33333 0C4.95217 0 5.54566 0.245833 5.98325 0.683417C6.42083 1.121 6.66667 1.71449 6.66667 2.33333V13.6667C6.66667 14.2855 6.42083 14.879 5.98325 15.3166C5.54566 15.7542 4.95217 16 4.33333 16C3.71449 16 3.121 15.7542 2.68342 15.3166C2.24583 14.879 2 14.2855 2 13.6667V2.33333C2 1.71449 2.24583 1.121 2.68342 0.683417ZM10.0169 0.683417C10.4545 0.245833 11.048 0 11.6668 0C12.2857 0 12.8792 0.245833 13.3167 0.683417C13.7543 1.121 14.0002 1.71449 14.0002 2.33333V13.6667C14.0002 14.2855 13.7543 14.879 13.3167 15.3166C12.8792 15.7542 12.2857 16 11.6668 16C11.048 16 10.4545 15.7542 10.0169 15.3166C9.57933 14.879 9.3335 14.2855 9.3335 13.6667V2.33333C9.3335 1.71449 9.57933 1.121 10.0169 0.683417Z",
		fill: "white"
	})
});
export default SvgPause;
